import Section from '@app/components/atoms/Section/Section'
import DataGrid from '@app/components/organisms/DataGrid/DataGrid'
import { CODE_STATUS } from '@app/constant/CodeConstant'
import { usePage } from '@inertiajs/inertia-react'
import { useTranslation } from 'react-i18next'

export default function VoucherCodeHistory() {
  const {
    props: { code_histories, routeName, voucher },
  } = usePage()
  const { t } = useTranslation()

  return (
    <Section simple>
      <DataGrid
        enableIndexColumn
        columns={[
          {
            id: 'code_id',
            Header: t('VOUCHER.CODE_ID'),
            accessor: 'code_id',
            type: 'string',
          },
          {
            id: 'status',
            Header: t('VOUCHER.STATUS'),
            accessor: ({ status }) => t(`CODES.${status.toUpperCase()}_HISTORY`),
            type: 'singleSelect',
            width: 70,
            options: [
              { value: CODE_STATUS.REDEEMED, name: t(`CODES.${CODE_STATUS.REDEEMED_NAME.toUpperCase()}_HISTORY`) },
              { value: CODE_STATUS.USED, name: t(`CODES.${CODE_STATUS.USED_NAME.toUpperCase()}_HISTORY`) },
            ],
          },
          {
            id: 'user_id',
            Header: t('VOUCHER.CUSTOMER_ID'),
            accessor: 'user_id',
            type: 'string',
            autoHide: true,
          },
          {
            id: 'created_at',
            Header: t('VOUCHER.TIME_TRANSACTION'),
            accessor: 'created_at',
            type: 'dateTime',
            autoHide: true,
          },
        ]}
        data={code_histories}
        enableCollapseFilter={false}
        params={{ merchant: voucher.merchant_id, voucher: voucher.id, tab: 'code_histories' }}
        queries={{
          merchant: voucher.merchant_id,
          voucher: voucher.id,
          tab: 'code_histories',
        }}
        routeName={routeName}
      />
    </Section>
  )
}
